import {
  COMBINED_LIST_RESPONSE,
  EXPORTERS_LIST_RESPONSE,
  GET_COMPANY_CONTACT_INFO_RESPONSE,
  GET_EXPORTER_ACCOUNT_INFO_RESPONSE,
  GET_EXPORTER_COMPANY_DETAILS_RESPONSE,
  GET_EXPORTER_CONTACT_INFO_RESPONSE,
  GET_EXPORTER_TRANSACTIONS_LIST_RESPONSE,
  GET_EXPORTER_VERIFICATION_INFO_RESPONSE,
  GET_IMPORTER_DETAILS_RESPONSE,
  IMPORTERS_LIST_RESPONSE
} from "./types";

const INITIAL_STATE = {
  importers: {
    list: [],
    meta: {}
  },
  exporters: {
    list: [],
    meta: {}
  },
  importerDetails: {},
  exporterDetails: {
    exporterCompanyDetails: {},
    exporterUserDetails: {},
    companyContactInfo: {},
    verificationInfo: {},
    transactions: {
      list: [],
      meta: {}
    },
    exporterAccountInfo: {}
  },
  websiteCurrency: sessionStorage.getItem("website-currency")
    ? JSON.parse(sessionStorage.getItem("website-currency"))
    : null,
  combined: {
    list: [],
    meta: {}
  }
};

const users = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IMPORTERS_LIST_RESPONSE:
      return {
        ...state,
        importers: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case EXPORTERS_LIST_RESPONSE:
      return {
        ...state,
        exporters: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case GET_IMPORTER_DETAILS_RESPONSE:
      return {
        ...state,
        importerDetails: action.payload
      };
    case GET_EXPORTER_COMPANY_DETAILS_RESPONSE:
      return {
        ...state,
        exporterDetails: {
          ...state.exporterDetails,
          exporterCompanyDetails: action.payload
        }
      };
    case GET_EXPORTER_CONTACT_INFO_RESPONSE:
      return {
        ...state,
        exporterDetails: {
          ...state.exporterDetails,
          exporterUserDetails: action.payload
        }
      };
    case GET_EXPORTER_VERIFICATION_INFO_RESPONSE:
      return {
        ...state,
        exporterDetails: {
          ...state.exporterDetails,
          verificationInfo: action.payload
        }
      };
    case GET_EXPORTER_TRANSACTIONS_LIST_RESPONSE:
      return {
        ...state,
        exporterDetails: {
          ...state.exporterDetails,
          transactions: {
            list: action.payload.list,
            meta: action.payload.meta
          }
        }
      };
    case GET_COMPANY_CONTACT_INFO_RESPONSE:
      return {
        ...state,
        exporterDetails: {
          ...state.exporterDetails,
          companyContactInfo: action.payload
        }
      };
    case GET_EXPORTER_ACCOUNT_INFO_RESPONSE:
      return {
        ...state,
        exporterDetails: {
          ...state.exporterDetails,
          exporterAccountInfo: action.payload
        }
      };
    case COMBINED_LIST_RESPONSE:
      return {
        ...state,
        combined: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    default:
      return state;
  }
};

export default users;
